import Vue from 'vue'
import AppAutosizeTextarea from '../../../components/AppAutosizeTextarea'
import AppRecruitService from '../../../components/AppRecruitService'

import WysiwygMixin from '../wysiwyg_mixin'
import ModalMixin from '../modal_mixin'

import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'
import ElementUIHelper from '../../../element-ui-helper'
import draggable from 'vuedraggable'

locale.use(lang)

Vue.component("app-autoresize-textarea", AppAutosizeTextarea)
Vue.component("app-recruit-field", AppRecruitService)

export default (data) => {

    // Summernote用の設定
    data.uploadImageUrl = '/admin/news/upload_img'
    data.uploadFileUrl = '/admin/news/upload_img'
    data.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
    data.errors = data.errors || {}
    // WYSIWYGミックスイン用の初期値
    data.wysiwygSelectedFileName = data.wysiwygSelectedFileName || null

    data.disabled = data.mode === 'show'

    const vm = new Vue({
        el: '#recruit-content',
        mixins: [WysiwygMixin, ModalMixin],
        components: {
            'draggable': draggable,
        },
        data() {
            return data;
        },
        mounted() {
            // contents_open_flgがtrueの場合のみSummernoteを初期化
            if (this.recruit_contents && this.recruit_contents.contents_open_flg) {
                this.$nextTick(() => {
                    this.initSummernote('#wysiwyg_editor', {
                        styleTags: ['p', 'h2', 'h3', 'h4'],
                        styleLabels: {
                            p: '標準',
                            h2: 'ヘッダー2',
                            h3: 'ヘッダー3',
                            h4: 'ヘッダー4',
                        },
                        hideButtons: ['customPicture', 'uploadFile']
                    })
                })
            }
            
            if (data.disabled) {
              $(':input').prop('disabled', true);
              $('input[type="button"],button[type="button"]').prop('disabled', false);
            }
        },
        watch: {
            'recruit_contents.contents_open_flg'(newVal) {
                // contents_open_flgがtrueになったときにSummernoteを初期化
                if (newVal && !this.editor) {
                    this.$nextTick(() => {
                        this.initSummernote('#wysiwyg_editor', {
                            styleTags: ['p', 'h2', 'h3', 'h4'],
                            styleLabels: {
                                p: '標準',
                                h2: 'ヘッダー2',
                                h3: 'ヘッダー3',
                                h4: 'ヘッダー4',
                            },
                            hideButtons: ['customPicture', 'uploadFile']
                        })
                    })
                }
            }
        },
        methods: {
            addRecruit: function (index) {
                this.$set(this.recruits, this.recruits.length,
                    [
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[0].id,
                            category_name: '',
                            recruit_id: 1,
                            sort_no: 1,
                            public_flg: 0,
                            recruit_name: this.recruit_master[0].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[1].id,
                            category_name: '',
                            recruit_id: 2,
                            sort_no: 2,
                            public_flg: 0,
                            recruit_name: this.recruit_master[1].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[2].id,
                            category_name: '',
                            recruit_id: 3,
                            sort_no: 3,
                            public_flg: 0,
                            recruit_name: this.recruit_master[2].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[3].id,
                            category_name: '',
                            recruit_id: 4,
                            sort_no: 4,
                            public_flg: 0,
                            recruit_name: this.recruit_master[3].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[4].id,
                            category_name: '',
                            recruit_id: 5,
                            sort_no: 5,
                            public_flg: 0,
                            recruit_name: this.recruit_master[4].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[5].id,
                            category_name: '',
                            recruit_id: 6,
                            sort_no: 6,
                            public_flg: 0,
                            recruit_name: this.recruit_master[5].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[6].id,
                            category_name: '',
                            recruit_id: 7,
                            sort_no: 7,
                            public_flg: 0,
                            recruit_name: this.recruit_master[6].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[7].id,
                            category_name: '',
                            recruit_id: 8,
                            sort_no: 8,
                            public_flg: 0,
                            recruit_name: this.recruit_master[7].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[8].id,
                            category_name: '',
                            recruit_id: 9,
                            sort_no: 9,
                            public_flg: 0,
                            recruit_name: this.recruit_master[8].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[9].id,
                            category_name: '',
                            recruit_id: 10,
                            sort_no: 10,
                            public_flg: 0,
                            recruit_name: this.recruit_master[9].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[10].id,
                            category_name: '',
                            recruit_id: 11,
                            sort_no: 11,
                            public_flg: 0,
                            recruit_name: this.recruit_master[10].name,
                            contents: '',
                            newItem: true
                        },
                        {
                            category_id: this.next_category_id(index),
                            recruit_master_id: this.recruit_master[11].id,
                            category_name: '',
                            recruit_id: 12,
                            sort_no: 12,
                            public_flg: 0,
                            recruit_name: this.recruit_master[11].name,
                            contents: '',
                            newItem: true
                        },
                    ]);
                this.$set(this.categories, this.categories.length,
                    {
                        id: this.next_category_id(index),
                        name: '',
                        button_transition: 0,
                    });
            },
            addRecruitItem: function (index) {
                this.recruits[index].push(
                    {
                        category_id: this.get_category_id(index),
                        recruit_id: this.next_id(index, 'recruit_id'),
                        sort_no: this.next_id(index, 'sort_no'),
                        public_flg: 0,
                        service_name: '',
                        contents: ''
                    });
                this.$set(this.recruits, index, this.recruits[index]);
            },
            deleteRecruit(delete_key, modal_id) {
                this.reset_errors(this.categories[delete_key].id);
                this.$delete(this.recruits, delete_key);
                this.$delete(this.categories, delete_key);
                this.modal = $(modal_id);
                this.modal.modal('hide');
            },
            deleteRecruitItem: function (index, delete_key, modal_id) {
                this.reset_insurance_errors(this.categories[index].id, this.recruits[index][delete_key].recruit_id);
                this.recruits[index].splice(delete_key, 1);
                this.$set(this.recruits, index, this.recruits[index]);
                this.modal = $(modal_id);
                this.modal.modal('hide');
            },
            draggableEnd: function (index) {
                Object.keys(this.recruits).map(function () {
                    this.recruits[index].map(function (service, key) {
                        this.reset_insurance_errors(service['category_id'], service['recruit_id']);
                        service['sort_no'] = key + 1;
                        return service;
                    }.bind(this), index);
                }.bind(this), index);
            },
            reset_errors: function (category_id) {
                if ('category_errors' in this.errors) {
                    this.$set(this.errors.category_errors.name, category_id, '');
                }
                if ('insurance_errors' in this.errors) {
                    this.$set(this.errors.insurance_errors.service_name, category_id, []);
                    this.$set(this.errors.insurance_errors.contents, category_id, []);
                }
            },
            reset_insurance_errors: function (category_id, recruit_id) {
                if ('insurance_errors' in this.errors) {
                    this.$set(this.errors.insurance_errors.service_name[category_id], recruit_id, '');
                    this.$set(this.errors.insurance_errors.contents[category_id], recruit_id, '');
                }
            },
            onChangePageOpen(event) {
                this.modal = $('#dialog_publish');
                this.modal.modal('show');
              },
            modalCancel(event) {
                this.modal = $('#dialog_publish');
                if (this.sales_policy.open_flg) {
                    this.sales_policy.open_flg = false;
                } else {
                    this.sales_policy.open_flg = true;
                }
                this.modal.modal('hide');
            },
            modalSettings(event) {
                this.modal = $('#dialog_publish');
                this.modal.modal('hide');
            },
            saveContent() {
                // Summernoteのコンテンツをクリーンアップして保存
                if (this.editor) {
                    // Vueモデルとtextareaに反映
                    const cleanedContent = this.getCleanContent()
                    this.recruit_contents.contents = cleanedContent
                    this.editor.summernote('code', cleanedContent)
                }
            },
            updateComment(contents) {
                // WYSIWYGエディタの内容をVueモデルに反映
                this.recruit_contents.contents = contents
            },
        },
        computed: {
            option: function () {
                return function (index) {
                    return {
                        animation: 100,
                        handle: '.drag_handle',
                        ghostClass: 'ghost',
                        group: {
                            name: 'recruit',
                            pull: (this.recruits[index].length > 1),
                            put: (this.recruits[index].length < 9)
                        }
                    };
                }
            },
            next_id: function () {
                return function (index, id_name) {
                    let next_id = (this.recruits[index].length <= 1) ?
                        this.recruits[index][0][id_name] :
                        this.recruits[index].reduce((a, b) => a[id_name] > b[id_name] ? a : b)[id_name];
                    return parseInt(next_id) + 1;
                }
            },
            next_category_id: function () {
                return function (index) {
                    return parseInt(this.recruits[index][0].category_id) + 1;
                }
            },
            get_category_id: function () {
                return function (index) {
                    return this.recruits[index][0]['category_id'];
                }
            },
        }
    });
}